import { useAppSelector } from 'store/hooks';
import { selectRoomToken } from 'features/room/roomSlice';
import { eventBus } from 'utils/eventBus';

export const usePageReload = () => {
  const roomToken = useAppSelector(selectRoomToken);

  const createReloadUrl = () => {
    const searchParams = new URLSearchParams(window.location.search);

    if (roomToken.jwt) {
      searchParams.set('token', roomToken.jwt);
    }

    if (eventBus.isEmbed) {
      searchParams.set('dsEmbedFrame', 'true');
    }

    const query = searchParams.toString();

    return query ? `${window.location.pathname}?${query}` : window.location.pathname;
  };

  return {
    createReloadUrl,
  };
};
